import { useI18n } from "@/common/I18nProvider";

export default function ServicesArea() {
  const { messages } = useI18n();
  const services = messages.services || {};
  const t = services.items || {};

  const cards = [
    {
      icon: "flaticon-trust",
      title: t.transport?.title || "وسائل النقل",
      desc: t.transport?.description || "نستورد أفضل أنواع وسائل النقل من جميع أنحاء العالم بجودة عالية.",
    },
    {
      icon: "flaticon-tap",
      title: t.oils?.title || "الزيوت",
      desc: t.oils?.description || "أجود أنواع الزيوت الصناعية وزيوت السيارات من أفضل المصانع.",
    },
    {
      icon: "flaticon-new-features",
      title: t.tires?.title || "الإطارات",
      desc: t.tires?.description || "أفضل أنواع الإطارات من أشهر العلامات التجارية العالمية.",
    },
    {
      icon: "flaticon-battery",
      title: t.batteries?.title || "البطاريات",
      desc: t.batteries?.description || "بطاريات عالية الجودة للسيارات والشاحنات بمواصفات عالمية.",
    },
    {
      icon: "flaticon-parts",
      title: t.spareParts?.title || "قطع الغيار",
      desc: t.spareParts?.description || "جميع قطع الغيار الأصلية والبديلة بأسعار مناسبة وجودة مضمونة.",
    },
    {
      icon: "flaticon-car",
      title: t.carAccessories?.title || "ملحقات السيارات",
      desc: t.carAccessories?.description || "جميع ملحقات السيارات والإكسسوارات اللازمة من مصادر موثوقة.",
    },
    {
      icon: "flaticon-support",
      title: t.maintenance?.title || "خدمات الصيانة",
      desc: t.maintenance?.description || "خدمات الصيانة والدعم الفني لجميع منتجاتنا مع ضمان الجودة.",
    },
    {
      icon: "flaticon-distribution",
      title: t.distribution?.title || "خدمات التوزيع",
      desc: t.distribution?.description || "شبكة توزيع واسعة تغطي جميع المناطق مع ضمان وصول المنتجات في الوقت المحدد.",
    },
  ];

  return (
    <div className="service-section">
      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="section-heading text-center mb-5">
          <span className="subtitle">{services.subtitle || "خدماتنا"}</span>
          <h2 className="mb-3">{services.title || "خدمات شركة البراق الدولية"}</h2>
          <p className="mb-0">{services.description || "نقدم مجموعة شاملة من الخدمات في مجال استيراد وسائل النقل والزيوت وملحقاتها، مع التزامنا بتقديم أفضل جودة وخدمة لعملائنا الكرام."}</p>
        </div>

        <div className="row g-4">
          {cards.map((card, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-lg-4">
              <div className="service-card translateY10">
                <div className="service-icon">
                  <i className={card.icon}></i>
                </div>
                <h4 className="mb-4">{card.title}</h4>
                <p className="mb-0">{card.desc}</p>
              </div>
            </div>
          ))}

        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>
    </div>
  )
}